import { type PropsWithChildren, useMemo } from 'react';

import { CustomerContext } from '../../context/CustomerContext';
import { useCustomerInformation } from '../../hooks/useCustomerInformation';

const CustomerContextProvider = ({ children }: PropsWithChildren): JSX.Element => {
    const { customerInfo, hasFetched } = useCustomerInformation();
    const isLoggedIn = !!customerInfo;

    const customerContextValue = useMemo(
        () => ({
            customerInfo,
            isLoggedIn,
            isNewCustomer: customerInfo?.isNewCustomer ?? false,
            hasFetched,
        }),
        [customerInfo, hasFetched, isLoggedIn],
    );

    return (
        <CustomerContext.Provider value={customerContextValue}>{children}</CustomerContext.Provider>
    );
};

export { CustomerContextProvider };
